export const transferStatus = {
	released: "Released",
	partReceived: "PartReceived",
	fullyReceived: "FullyReceived",
	completed: "Completed",
	completedWithVariances: "CompletedWithVariances",
	completedManuallyRecievedInSK: "CompletedManuallyRecievedinSK",
	cancelled: "Cancelled",
	inTransit: "InTransit",
};
